import {
  DRIVERS_LOAD_REQUEST,
  DRIVERS_LOAD_SUCCESS,
  DRIVERS_LOAD_FAILURE,
  DRIVERS_REVALIDATE_REQUEST,
  DRIVERS_UPSERT_ONE
} from '../types/drivers-types';

const initialState: {
  loading: boolean;
  error: any;
  success: boolean;
  drivers: any[];
  lastFetchedAt: number | null;
  revalidating: boolean;
} = {
  loading: false,
  error: null,
  success: false,
  drivers: [],
  // Epoch ms of the last successful list fetch — used by drivers-page to decide
  // whether to do a foreground load, a silent background revalidate, or nothing.
  lastFetchedAt: null,
  // True while a background (stale-while-revalidate) fetch is in flight.
  revalidating: false
};

function drivers(state = initialState, action: any = null) {
  switch (action.type) {
    case DRIVERS_LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case DRIVERS_REVALIDATE_REQUEST:
      // Background fetch — keep `loading` false so the skeleton doesn't flash
      // over cached rows.
      return {
        ...state,
        revalidating: true,
        error: null
      };

    case DRIVERS_LOAD_FAILURE:
      // Keep `drivers` in place: a failed background revalidate shouldn't wipe
      // the list the user is currently looking at.
      return {
        ...state,
        loading: false,
        revalidating: false,
        error: action.error
      };

    case DRIVERS_LOAD_SUCCESS:
      return {
        ...state,
        drivers: action.payload,
        success: true,
        loading: false,
        revalidating: false,
        lastFetchedAt: Date.now(),
        error: null
      };

    case DRIVERS_UPSERT_ONE: {
      // Merge-by-id so partial mutation responses don't blow away list-only
      // fields (avatars, vehicle metadata, etc.).
      const incoming = action.payload;
      if (!incoming || !incoming.id) return state;
      const idx = state.drivers.findIndex((d: any) => d.id === incoming.id);
      if (idx === -1) {
        return { ...state, drivers: [...state.drivers, incoming] };
      }
      const next = state.drivers.slice();
      next[idx] = { ...next[idx], ...incoming };
      return { ...state, drivers: next };
    }

    default:
      return state;
  }
}

export default drivers;
